import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { PasswordChangeRoute } from './password-change.route';
import { PasswordChangePresenterComponent } from './password-change-presenter/password-change-presenter.component';
import { PasswordChangeFeatureComponent } from './password-change-feature/password-change-feature.component';

@NgModule({
    declarations: [
        PasswordChangeFeatureComponent,
        PasswordChangePresenterComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule.forChild({
            states: [PasswordChangeRoute]
        })
    ]
})
export class PasswordChangeModule {}
